# A simple date parsing and validation directive, works best alongside a ui.mask
angular.module('wbComponents').directive 'inputDate', ->
  restrict: 'A'
  require: 'ngModel'

  link: ($scope, $el, $attrs, ngModel) ->
    min = moment('0001-01-01')
    max = moment('9999-12-31')
    $attrs.$observe 'min', (v) ->
      min = if v is 'today' then moment() else moment(v)
      ngModel.minDate = min.format('YYYY-MM-DD')
    $attrs.$observe 'max', (v) ->
      max = if v is 'today' then moment() else moment(v)
      ngModel.maxDate = max.format('YYYY-MM-DD')

    ngModel.$formatters.push (value) ->
      if value? && moment(value).isValid()
        moment(value).format("YYYY-MM-DD")
      else
        ''

    ngModel.$validators.invalidDate = (model) ->
      value = moment(model, "YYYY-MM-DD")
      value? && value.isValid()

    ngModel.$validators.minDate = (model) ->
      value = moment(model, "YYYY-MM-DD")
      return true unless value?.isValid()
      value?.isAfter(min)

    ngModel.$validators.maxDate = (model) ->
      value = moment(model, "YYYY-MM-DD")
      return true unless value?.isValid()
      value?.isBefore(max)
